import React from "react";
import { createRouter, stringifySearchWith } from "@tanstack/react-router";
import type { RouteIds } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { DefaultPendingComponent } from "shared-ts-router";
import qs from "query-string";
import { QueryClient } from "@tanstack/react-query";
export const queryClient = new QueryClient();
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPendingComponent: () => <DefaultPendingComponent />,
  scrollRestoration: true,
  stringifySearch: stringifySearchWith((value) =>
    qs.stringify(value, {
      // ...options
    })
  ),
  context: { queryClient },
});

export type RouterType = typeof router;
export type RouterIds = RouteIds<RouterType["routeTree"]>;
